import { Row, Col } from "react-bootstrap";
import { CrudPlaceholderInput } from "../../../../../general/modules/commons/crud/inputs/crudPlaceholderInput";

export const ShelvingUnitMutateFormTemplate = () => {
  return (
    <Row>
      <Col xs={12}>
        <CrudPlaceholderInput name="identifier" />
      </Col>
    </Row>
  );
};
